import Component from './twitter_campaign_prize.vue'
export default Component
